import axios from "axios";
export default {
  async Login({ commit }, Form) {
    try {
      let response = await axios.post("/user_login", Form);
      console.log(response.data);
      localStorage.setItem("token", response.data.user.api_token)
      localStorage.setItem("user", JSON.stringify(response.data.user));
      commit("setUser", { user: response });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    commit("logout");
  },
};
